var React = require('react');

function Shape6 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M123.816 27.269C128.821 37.7674 131.406 50.0339 133.384 61.5746C136.916 82.2451 139.135 106.084 125.178 121.691C113.617 134.602 94.6773 137.363 77.3685 137.873C55.4905 138.498 31.0758 135.672 16.6844 119.119C8.82709 110.083 5.15135 98.1787 2.75829 86.4432C-2.51464 60.5306 2.00504 32.8342 26.4156 18.3918C39.6364 11.302 54.8645 4.57869 69.5992 1.6837C82.1704 -0.787085 95.8951 0.167344 106.744 7.00926C114.503 11.8965 119.901 19.0359 123.816 27.269Z"}));
}

Shape6.defaultProps = {"width":"137","height":"138","viewBox":"0 0 137 138","fill":"none"};

module.exports = Shape6;

Shape6.default = Shape6;
